/**
 * Schedule a call back VHT Widget
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { bindActionCreators } from 'redux';
import { hideVhtWidget } from '../actions/action-update-user-selection';
import { getVhtWidgetId, getResolutionQueueId, getVhtWidgetAdditionalInfo } from '../../lib/globalHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';

class VhtwidgetContainer extends Component {
  static renderModalPrompt(vhtWidgetId) {
    // Adding the VHT Widget div tag with widget id from remote config
    return <div className="vht-widget" data-vht-organization-id="7bedc0e789e5905a" data-vht-widget-id={vhtWidgetId} />;
  }

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    trackLink({ id: 'vhtWidgetContactUsPage', link: 'schedule-call-back-widget-closed' });
    this.props.hideVhtWidget();
  }

  renderVhtPrompt(vhtWidgetId) {
    const { isVhtWidgetDisplayed } = this.props;
    return (
      <div>
        <Modal isOpen={isVhtWidgetDisplayed} type="dialog" width="medium" role="contentinfo" onCancel={this.closeModal}>
          <ModalBody className="vht-widget-modal-body">{VhtwidgetContainer.renderModalPrompt(vhtWidgetId)}</ModalBody>
        </Modal>
      </div>
    );
  }

  renderVhtScript() {
    const { isVhtWidgetDisplayed, topicsDisplay, contactChannels } = this.props;
    if (isVhtWidgetDisplayed) {
      /*
        when topicsDisplay is True i.e. user is at HC homepage, get the resolution queue id from window object
        when topicsDisplay is false i.e. user is at topic content page, get the resolution queue id from store
      */
      const channels = topicsDisplay ? window.channelDecisions : contactChannels?.IDIAvailability;
      const resolutionQueueId = getResolutionQueueId(channels);
      // Only once the vht widget div tag is available we need to trigger this init function to render vht widget
      // so adding the timeout function
      try {
        if (window.vhtConversationBridgeClient && typeof window.vhtConversationBridgeClient.init === 'function') {
          // send queueId to VHT
          window.vhtConversationBridgeClient.events.setUserData = function () {
            // send additional information to VHT callback
            return getVhtWidgetAdditionalInfo(resolutionQueueId);
          };
          return setTimeout(() => {
            const isWidgetTagExist = document.getElementsByClassName('vht-widget');
            if (isWidgetTagExist && isWidgetTagExist.length > 0) {
              // successfull FPTI
              trackPage({ id: 'vhtWidgetSuccess', link: 'schedule-call-back-vht-widget-shown' });
              return window.vhtConversationBridgeClient.init();
            }
            // if widget html tag does not exist triggering error FPTI
            return trackPage({
              id: 'vhtWidgetError',
              link: 'schedule-call-back-widget-not-shown-html-tag-not-existed',
            });
          }, 10);
        }
        // if window init does not exist triggering error FPTI
        return trackPage({
          id: 'vhtWidgetError',
          link: 'schedule-call-back-widget-not-shown-init-function-not-existed',
        });
      } catch (error) {
        // Error while opening vht widget
        return trackPage({ id: 'vhtWidgetError', link: 'schedule-call-back-widget-error' });
      }
    }
    return null;
  }

  render() {
    const vhtWidgetId = getVhtWidgetId();
    // Remote config check
    if (vhtWidgetId) {
      return (
        <div>
          {this.renderVhtPrompt(vhtWidgetId)}
          {this.renderVhtScript()}
        </div>
      );
    }

    return <div />;
  }
}
VhtwidgetContainer.propTypes = {
  hideVhtWidget: PropTypes.func.isRequired,
  isVhtWidgetDisplayed: PropTypes.bool,
  topicsDisplay: PropTypes.bool,
  contactChannels: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

VhtwidgetContainer.defaultProps = {
  isVhtWidgetDisplayed: false,
  topicsDisplay: true,
};

function mapStateToProps(state) {
  return {
    topicsDisplay: state.selectResult.topicsDisplay,
    contactChannels: state.contactChannels,
    isVhtWidgetDisplayed: state.contactChannels.isVhtWidgetDisplayed,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ hideVhtWidget }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VhtwidgetContainer);
